export const TASKS_STATUS = {
  PENDING: "pending",
  COMPLETED: "completed",
};

export const STATUS_VALUES = ["", "Approved", "Rejected"];

export const STATUS_KEYS = {
  APPROVED: "approved",
  PENDING: "pending",
  REJECTED: "rejected",
  URGENT: "urgent",
  HIGH: "high",
  MEDIUM: "medium",
  LOW: "low",
};

export const PAGE_LIMIT = 20;

export const PRIORITY_OPTIONS = [
  { label: "Urgent", value: "urgent" },
  { label: "High", value: "high" },
  { label: "Medium", value: "medium" },
  { label: "Low", value: "low" },
];

export const COLLECTION_NAME_MAP = {
  creator: "Design  Content Author",
};

export const REQUEST_TYPE = {
  POST: "post",
  PUT: "put",
  PATCH: "patch",
  DELETE: "delete",
};

export const SPOC_TYPE_OPTIONS = [
  { label: "Design", value: "design" },
  { label: "Video", value: "video" },
  { label: "Animation", value: "animation" },
];
